import t from "react";
import n from "prop-types";
import r from "react-focus-lock";
import s from "react-transition-group/Transition";
import o from "classnames";
import { N as p } from "./NoClickOutline-CllwvnB9.es.js";
import './Modal.css';const d = "Modal-module__launcher___rq1MO", c = "Modal-module__panel___pXonG", h = "Modal-module__right___4H9uz", u = "Modal-module__modalWrapper___De8Qx", m = "Modal-module__connected___fl57R", a = {
  launcher: d,
  panel: c,
  right: h,
  modalWrapper: u,
  connected: m
}, f = (i) => ({
  transition: `opacity ${i}ms ease-in-out`,
  opacity: 0
}), _ = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0, pointerEvents: "none" },
  exited: { opacity: 0, pointerEvents: "none" }
};
class l extends t.Component {
  state = { open: !1 };
  componentDidMount() {
    document.body.addEventListener("keydown", this.handleKeyDown), document.body.addEventListener("click", this.handleClick);
  }
  componentWillUnmount() {
    document.body.removeEventListener("click", this.handleClick), document.body.removeEventListener("keydown", this.handleKeyDown);
  }
  handleClick = (e) => {
    !this.launcher.contains(e.target) && !this.panel.contains(e.target) && this.handleOpen(!1);
  };
  handleKeyDown = (e) => {
    e.key === "Escape" && this.handleOpen(!1);
  };
  handleOpen = (e) => {
    this.setState({ open: e });
  };
  render() {
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        className: o(
          a.modalWrapper,
          this.state.open && this.props.floating && a.connected,
          this.props.align === "right" && a.right
        )
      },
      /* @__PURE__ */ t.createElement(
        p.Button,
        {
          className: a.launcher,
          onClick: () => this.handleOpen(!this.state.open),
          ref: (e) => {
            this.launcher = e;
          }
        },
        this.props.launcher(this.state.open)
      ),
      /* @__PURE__ */ t.createElement(
        "div",
        {
          ref: (e) => {
            this.panel = e;
          },
          style: {
            position: "absolute",
            width: "100%",
            left: this.props.align === "right" ? null : 0,
            right: this.props.align === "right" ? 0 : null
          }
        },
        /* @__PURE__ */ t.createElement(
          s,
          {
            in: this.state.open,
            timeout: this.props.duration
          },
          (e) => /* @__PURE__ */ t.createElement(r, { disabled: !this.state.open, returnFocus: !0 }, /* @__PURE__ */ t.createElement(
            "div",
            {
              className: o(
                a.panel,
                this.props.align === "right" && a.right
              ),
              role: "dialog",
              "aria-modal": !0,
              "aria-label": this.props.ariaLabel,
              "aria-labelledby": this.props.ariaLabelledBy,
              style: {
                ...f(this.props.duration),
                ..._[e],
                width: this.props.align === "left" ? "100%" : void 0
              }
            },
            e !== "exited" && this.props.panel(this.handleOpen)
          ))
        )
      )
    );
  }
}
l.propTypes = {
  ariaLabel: n.string,
  ariaLabelledBy: n.string,
  align: n.oneOf(["left", "right"]).isRequired,
  floating: n.bool.isRequired,
  launcher: n.func.isRequired,
  panel: n.func.isRequired,
  duration: n.number
};
l.defaultProps = {
  ariaLabel: null,
  ariaLabelledBy: null,
  duration: 250
};
export {
  l as M
};
